var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTermsIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 19,
    viewBox: "0 0 19 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_16240_12419)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.86888 15.148C6.31215 15.148 6.53379 15.148 6.7357 15.2229C6.76374 15.2333 6.79139 15.2447 6.81858 15.2572C7.01433 15.347 7.17105 15.5037 7.48449 15.8172C8.20591 16.5386 8.56662 16.8993 9.01046 16.9326C9.07013 16.937 9.13006 16.937 9.18974 16.9326C9.63357 16.8993 9.99429 16.5386 10.7157 15.8172C11.0291 15.5037 11.1859 15.347 11.3816 15.2572C11.4088 15.2447 11.4365 15.2333 11.4645 15.2229C11.6664 15.148 11.888 15.148 12.3313 15.148H12.4131C13.544 15.148 14.1095 15.148 14.4608 14.7966C14.8121 14.4453 14.8121 13.8798 14.8121 12.7489V12.6671C14.8121 12.2239 14.8121 12.0022 14.8871 11.8003C14.8975 11.7723 14.9089 11.7446 14.9214 11.7174C15.0112 11.5217 15.1679 11.365 15.4813 11.0515C16.2028 10.3301 16.5635 9.96939 16.5967 9.52555C16.6012 9.46588 16.6012 9.40595 16.5967 9.34627C16.5635 8.90244 16.2028 8.54173 15.4813 7.8203C15.1679 7.50686 15.0112 7.35014 14.9214 7.15439C14.9089 7.1272 14.8975 7.09956 14.8871 7.07152C14.8121 6.8696 14.8121 6.64797 14.8121 6.20469V6.12293C14.8121 4.992 14.8121 4.42654 14.4608 4.0752C14.1095 3.72387 13.544 3.72387 12.4131 3.72387H12.3313C11.888 3.72387 11.6664 3.72387 11.4645 3.64895C11.4365 3.63855 11.4088 3.62709 11.3816 3.61462C11.1859 3.52482 11.0291 3.3681 10.7157 3.05466C9.99429 2.33324 9.63357 1.97253 9.18974 1.93927C9.13006 1.9348 9.07013 1.9348 9.01046 1.93927C8.56662 1.97253 8.20591 2.33324 7.48449 3.05466C7.17105 3.3681 7.01433 3.52482 6.81858 3.61462C6.79139 3.62709 6.76374 3.63855 6.7357 3.64895C6.53379 3.72387 6.31215 3.72387 5.86888 3.72387H5.78711C4.65619 3.72387 4.09072 3.72387 3.73939 4.0752C3.38805 4.42654 3.38806 4.992 3.38806 6.12293V6.20469C3.38806 6.64797 3.38805 6.8696 3.31314 7.07152C3.30273 7.09956 3.29128 7.1272 3.27881 7.15439C3.18901 7.35014 3.03229 7.50686 2.71885 7.8203C1.99743 8.54173 1.63671 8.90244 1.60345 9.34627C1.59898 9.40595 1.59898 9.46588 1.60345 9.52555C1.63671 9.96939 1.99742 10.3301 2.71885 11.0515C3.03229 11.365 3.18901 11.5217 3.27881 11.7174C3.29128 11.7446 3.30273 11.7723 3.31314 11.8003C3.38805 12.0022 3.38806 12.2239 3.38806 12.6671V12.7489C3.38806 13.8798 3.38805 14.4453 3.73939 14.7966C4.09072 15.148 4.65619 15.148 5.78711 15.148H5.86888Z",
    stroke: "#383C42",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.3501 7.18591L6.8501 11.6859",
    stroke: "#383C42",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.3501 11.6859H11.342H11.3501Z",
    fill: "#383C42"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.85817 7.18591H6.8501H6.85817Z",
    fill: "#383C42"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.3501 11.6859H11.342M6.85817 7.18591H6.8501",
    stroke: "#383C42",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_16240_12419"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "white",
    transform: "translate(0.100098 0.435913)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTermsIcon);
export default __webpack_public_path__ + "static/media/terms-icon.893992f69fd6a1e8c66c701ec9a066d7.svg";
export { ForwardRef as ReactComponent };